module.exports = __webpack_public_path__ + "825ccbf8695caf1bd21b4b8f60e87b97.json";


//////////////////
// WEBPACK FOOTER
// ./src/portal/i18n/zh.json
// module id = 1122
// module chunks = 0